import { ReactComponent as ClockIcon } from "src/assets/icons/clock-icon.svg";
import { ReactComponent as AirdropIcon } from "src/assets/icons/airdrop-icon.svg";
import { ReactComponent as MonitorIcon } from "src/assets/icons/monitor-icon.svg";
import { ReactComponent as CollaborationIcon } from "src/assets/icons/tag-icon.svg";
import { IAdvantageCard } from "./types";

export const EXPERIENCE_AND_APPROACH_CARDS: IAdvantageCard[] = [
  {
    id: "1",
    icon: ClockIcon,
    title: "ДОСВІД І ЕКСПЕРТИЗА",
    description:
      "<p>Ми маємо 15+ досвіду роботи в індустрії і компаніях Великої четвірки.</p><br /><p>Ми працювали над 20+ проектами для компаній з FORTUNE 500 і більше 45+ проектами для інших компаній.</p>",
  },
  {
    id: "2",
    icon: AirdropIcon,
    title: "ІНДИВІДУАЛЬНИЙ ПІДХІД",
    description:
      "<p>Ми формуємо команду профільних фахівців під кожен проект індивідуально.</p><br /><p>Оскільки зацікавлені не тільки в тому, щоб надати швидкий результат, а й перевершити Ваші очікування.</p>",
  },
];

export const INNOVATION_AND_PRICE_CARDS: IAdvantageCard[] = [
  {
    id: "3",
    icon: MonitorIcon,
    title: "ІННОВАЦІЙНІ РІШЕННЯ",
    description:
      "<p>Ми працюємо в MS Dynamics NAV | 1C | SAP | Twinfield | Xero | QuickBooks | SharePoint.</p><br /><p>Використовуємо передові облікові системи та платформи із захисту / обміну даних, враховуючи специфіку бізнесу та побажання кожного.</p>",
  },
  {
    id: "4",
    icon: CollaborationIcon,
    title: "ЦІНОВА ПОЛІТИКА",
    description:
      "<p>Ніяких прихованих комісій і непередбачених витрат.</p><br /><p>Формуємо чесну ціну на послуги, тому що зацікавлені у довготривалій співпраці та взаємовигідному партнерстві.</p>",
  },
];
